import React from 'react'

const OurImpact = () => {
  return (
    <div>
      
    </div>
  )
}

export default OurImpact
